import { HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { StaticTextDataDto } from '@app/data/dtos/static-text/static-text-data-dto';
import { mapStaticText } from '@app/data/mappers/static-text/static-text.mapper';
import { StaticTextRepository } from '@app/domain/repositories/static-text/static-text.repository.contract';
import { StaticText } from '@app/entities/models/static-text/static-text.model';
import { ENV } from '@environments/environment';
import { SECTION_KEY } from '@services/interceptors/error-sections.interceptor/error-sections.interceptor';

import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({
  providedIn: 'root'
})
export class StaticTextRepositoryImpl extends MRepository implements StaticTextRepository {
  constructor() {
    super(`${ENV.API_URL}`);
  }

  getStaticText(key: string, lang?: string): Observable<StaticText> {
    let params = new HttpParams();

    params = params.append('key', key);
    if (lang) {
      params = params.append('lang', lang);
    }

    return this.get<StaticTextDataDto>(`/static-text`, {
      params,
      context: new HttpContext().set(SECTION_KEY, 'static-text')
    }).pipe(map(mapStaticText));
  }
}
